import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import SellIcon from "@mui/icons-material/Sell";

type TagInputProps = {
  className?: string;
  tags?: string[];
  viewOnly?: boolean;
  helperText?: string;
  onTagsUpdated?: (tags: string[]) => void;
  onTagRemoved?: (tag: string) => void;
};

export default function TagInput(props: Readonly<TagInputProps>) {
  const { className, tags, viewOnly, helperText, onTagsUpdated, onTagRemoved } = props;

  const [tagInputOpen, setTagInputOpen] = useState<boolean>(false);

  return (
    <Autocomplete
      className={className}
      open={tagInputOpen}
      onOpen={() => !viewOnly && setTagInputOpen(true)}
      onClose={() => setTagInputOpen(false)}
      multiple
      disabled={viewOnly}
      options={[]}
      freeSolo
      filterOptions={(options, params) => params.inputValue === '' ? [] : [params.inputValue]}
      getOptionLabel={(option) => `Add "${option}" as new tag`}
      blurOnSelect
      clearOnBlur
      renderValue={(selected) => (
        <>
          {selected.map((option) => (
            <Chip
              key={option}
              title="Click to remove tag"
              label={option}
              onDelete={() => {
                onTagRemoved?.(option);
              }}
              sx={{ marginRight: 0.5 }}
            />
          ))}
        </>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          slotProps={{
            input: { 
              ...params.InputProps, 
              readOnly: viewOnly,
              endAdornment: !tags?.length && <SellIcon color="disabled" />,
            }
          }}
          label="Tags"
          placeholder="Add new tag"
          helperText={helperText}
        />
      )}
      value={tags}
      onChange={(_event, value) => {
        onTagsUpdated?.(value);
      }}
    />
  );
}
